import styled from "styled-components";

import { grayScale } from "@enkor/design/colors";
import { Typo } from "@enkor/design/components";

export const EventListWrapper = styled.section`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const SectionTitle = styled(Typo.Heading)`
  color: ${grayScale[700]};
`;
